import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, EditableDBItemV3, LL_H_C, LL_V_L, SimpleListAdapter, TS_Checkbox, TS_DropDown, TS_Input, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_Action, DBDef_OrderGroup, EditableStateTypeTypes, PathwayStateType_Initial, PathwayStateTypeLabelMap, pathwayType_SingleState } from '@app/pathway-shared';
import { filterDuplicates, ImplementationMissingException, MUSTNeverHappenException, sortArray, voidFunction } from '@nu-art/ts-common';
import { dispatch_PathwayStateRealtimeChanges } from '../../../dispatchers.js';
import { ModuleFE_LogTemplate_OLD } from '@app/hcs-frontend';
import { ICONS } from '@app/styles';
import { Empty_PathwayState } from '../../../consts.js';
import { Header_Pathway } from '../../../headers/Header_Pathway.js';
import { Header_PathwayState } from '../../../headers/Header_PathwayState.js';
import { Dialog_Confirmation, QuaiManager_DropDownCaret } from '@app/styles';
import { ModuleFE_Action, ModuleFE_OrderGroup, ModuleFE_Pathway, ModuleFE_PathwayState, ModuleFE_PathwayTransition } from '../../../../../_entity.js';
import { basicSyncEventRefresh, updateResolutionFunctionTitle } from '../../../utils.js';
import { Editor_PreconditionTimeConstraint } from './componentes/precondition-editor/Editor_Preconditions.js';
import './Renderer_PathwayStateEditor.scss';
import { DropDown_Precondition } from '../../../../../_entity/pathway-state/ui-components.js';
import { ModuleFE_PathwayEditor } from '../../../../../modules/index.js';
import { Renderer_PathwayItemChildSelector } from '../../../renderers/Renderer_PathwayItemChildSelector.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { Dropdown_PathwayStateType } from '../../../../../_enum/pathway-state-type/index.js';
export class Renderer_PathwayStateEditor extends TS_EditableItemComponentProto {
    __onPathwayStateUpdated(...params) {
        const pathwayStateId = this.state.editable.get('_id');
        if (!pathwayStateId)
            return;
        basicSyncEventRefresh(pathwayStateId, params, () => this.props.functions.selectPathwayState(pathwayStateId, true), () => this.props.functions.deselectPathwayState());
    }
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.pathwayId = ModuleFE_PathwayEditor.getViewedPathwayId();
        if (!state.pathwayId)
            throw new MUSTNeverHappenException('cannot render the component without pathway Id in context ');
        state.statesUnderPathway = ModuleFE_PathwayState.cache.filter(ps => ps.pathwayIds.includes(state.pathwayId));
        return state;
    }
    // ######################## Logic ########################
    nameUnique = () => {
        const currentState = this.state.editable.item;
        const currentName = currentState.name?.toLowerCase();
        if (!currentName)
            return true;
        return !this.state.statesUnderPathway.find(ps => ps.name.toLowerCase() === currentName && ps._id !== currentState._id);
    };
    saveImpl = async (createNew, detachState = false) => {
        // deselect item to avoid rendering issues
        this.props.functions.deselectPathwayState();
        let _pathwayState;
        if (detachState) {
            const response = await ModuleFE_PathwayState._v1.detachStateContext({
                pathwayState: this.state.editable.item,
                pathwayId: this.state.pathwayId
            }).executeSync();
            _pathwayState = response.pathwayStates[0];
        }
        else {
            const pathwayState = this.state.editable;
            _pathwayState = await pathwayState.save();
        }
        //update all related resolution function label
        const associatedTransitions = ModuleFE_PathwayTransition.cache.filter(transition => [transition.targetId,
            transition.sourceId].includes(_pathwayState._id));
        await Promise.all(associatedTransitions.map(async (transition) => {
            return updateResolutionFunctionTitle(transition._id, [transition.sourceId, transition.targetId]);
        }));
        //Post Save logic
        if (!createNew)
            return this.props.functions.deselectPathwayState();
        const newPathwayState = new EditableDBItemV3(Empty_PathwayState(this.state.pathwayId), ModuleFE_PathwayState);
        this.props.functions.selectPathwayState(newPathwayState);
    };
    onSave = async (createNew = false) => {
        if (!this.canSave())
            return;
        const pathway = ModuleFE_Pathway.cache.unique(this.state.pathwayId);
        if (!pathway)
            throw new MUSTNeverHappenException(`cannot find pathway with id ${this.state.pathwayId}`);
        // This is not a child pathway, or a new state, or not belonged to the pathway parent
        if (!pathway._parentId || !this.state.editable.item._id || !this.state.editable.item.pathwayIds?.includes(pathway._parentId))
            return this.saveImpl(createNew);
        return Dialog_Confirmation.show({
            content: _jsx(_Fragment, { children: _jsx("div", { children: "By editing this state, the state and its transitions & resolution functions will be detached from the parent and won't receive more updates" }) }),
            buttons: [
                {
                    label: 'Yes, Edit',
                    isAsync: true,
                    action: () => this.saveImpl(createNew, true)
                },
                {
                    label: 'Cancel', action: voidFunction, isPreferred: true
                }
            ]
        });
    };
    canSave = () => {
        const pathwayState = this.state.editable.item;
        return !!pathwayState.name && this.nameUnique() && !!pathwayState.type && !!pathwayState.label;
    };
    onCancel = () => {
        const stateId = this.state.editable.get('_id');
        if (!stateId)
            return this.props.functions.deselectPathwayState();
        this.props.toggleMode();
        // Can assume it exists because of the condition above
        this.props.functions.selectPathwayState(stateId);
    };
    onStateNameChange = (value) => {
        const pathwayState = this.state.editable;
        pathwayState.set('name', value);
        this.forceUpdate();
        dispatch_PathwayStateRealtimeChanges.dispatchUI();
    };
    onStateLabelChange = (value) => {
        const pathwayState = this.state.editable;
        pathwayState.set('label', value);
    };
    filterAddableTypes = (type) => {
        const pathwayId = this.state.pathwayId;
        const allPathwayStates = (ModuleFE_PathwayState.cache
            .filter((state) => state.pathwayIds.includes(pathwayId)))
            .map(state => state.type);
        // Editable state types and initial type can be added any time. other types can be added only once.
        return EditableStateTypeTypes.includes(type) || type === PathwayStateType_Initial || !allPathwayStates.includes(type);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'pathway-state-editor', style: { padding: '30px', gap: '10px' }, children: [this.renderHeader(), this.renderForm(), this.renderButtons()] });
    }
    renderButtons = () => {
        const pathway = ModuleFE_Pathway.cache.unique(this.state.pathwayId);
        if (!pathway)
            throw new MUSTNeverHappenException(`Could not get pathway for id ${this.state.pathwayId}`);
        const disabled = !this.canSave();
        return _jsxs(LL_H_C, { className: 'pathway__bottom-buttons', children: [_jsx(Button, { variant: 'secondary', onClick: this.onCancel, children: "Cancel" }), pathway.type !== pathwayType_SingleState &&
                    _jsx(Button, { variant: 'primary', onClick: () => this.onSave(true), disabled: disabled, children: "Add Another State" }), _jsx(Button, { variant: 'primary', onClick: () => this.onSave(), className: 'preferred-action', disabled: disabled, children: "Save" })] });
    };
    // ######################## Render - Header ########################
    renderHeader = () => {
        const pathway = ModuleFE_Pathway.cache.unique(this.state.pathwayId);
        if (!pathway)
            throw new MUSTNeverHappenException(`Could not get pathway for id ${this.state.pathwayId}`);
        return _jsxs(_Fragment, { children: [_jsx(Header_Pathway, { pathway: new EditableDBItemV3(pathway, ModuleFE_Pathway), allowActions: false, functions: this.props.functions }), _jsx(Header_PathwayState, { pathwayState: this.state.editable, functions: this.props.functions })] });
    };
    // ######################## Render - Form ########################
    renderForm = () => {
        return _jsxs(LL_V_L, { className: 'pathway__form', children: [this.renderStateName(), this.renderStateLabel(), this.renderIgnoreDocumentation(), this.renderStateType(), this.renderPreconditions(), this.renderLogTemplates(), this.childrenSelector()] });
    };
    renderStateLabel = () => {
        const pathwayState = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsxs("div", { className: 'pathway__form__label', children: ["State Label", _jsx("sup", { children: "*" })] }), _jsx(TS_Input, { type: 'text', value: pathwayState.item.label, onChange: this.onStateLabelChange })] });
    };
    renderStateName = () => {
        const pathwayState = this.state.editable;
        const nameUniquenessError = !this.nameUnique();
        return _jsxs(_Fragment, { children: [_jsxs("div", { className: 'pathway__form__label', children: ["State Name", _jsx("sup", { children: "*" })] }), _jsx(TS_Input, { type: 'text', className: _className(nameUniquenessError && 'error'), value: pathwayState.item.name, onChange: this.onStateNameChange }), nameUniquenessError &&
                    _jsx("div", { className: 'pathway__form__data', children: "A state with this name already exists in this pathway. Please create a unique name." })] });
    };
    renderStateType = () => {
        const pathwayState = this.state.editable;
        const type = pathwayState.item.type;
        // limit edit of state types - type cannot be edited.
        const canEditStateType = !type || EditableStateTypeTypes.includes(type);
        return _jsxs(_Fragment, { children: [_jsxs("div", { className: 'pathway__form__label', children: ["State Type", _jsx("sup", { children: "*" })] }), !canEditStateType
                    ? _jsx("div", { className: 'pathway__form__type', children: PathwayStateTypeLabelMap[type] })
                    : _jsx(Dropdown_PathwayStateType.selectable, { selected: type, onSelected: type => {
                            pathwayState.set('type', type);
                            this.forceUpdate();
                        }, queryFilter: (type) => this.filterAddableTypes(type) })] });
    };
    renderPreconditions = () => {
        const editable = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'pathway__form__label', children: "Preconditions" }), _jsx(TS_MultiSelect_V2, { editable: editable, prop: 'preconditions', itemsDirection: 'vertical', getItemKey: (p, idx) => `${p.itemPointer.dbKey}-${p.itemPointer.id}-${p.expressionId ?? 'x'}-${idx}`, sort: (items) => sortArray(items, item => {
                        switch (item.itemPointer.dbKey) {
                            case DBDef_Action.dbKey:
                                return ModuleFE_Action.cache.unique(item.itemPointer.id)?.name ?? 'N/A';
                            case DBDef_OrderGroup.dbKey:
                                return ModuleFE_OrderGroup.cache.unique(item.itemPointer.id)?.name ?? 'N/A';
                            default:
                                throw new ImplementationMissingException(`Sort handling for dbKey ${item.itemPointer.dbKey} missing!`);
                        }
                    }), itemRenderer: (precondition, onDelete, disabled, itemIndex, listEditable) => {
                        const editablePrecondition = listEditable.editProp(itemIndex, {});
                        return _jsxs(_Fragment, { children: [_jsx(Editor_PreconditionTimeConstraint, { editable: editablePrecondition }), _jsx(ICONS.x.component, { onClick: onDelete })] });
                    }, selectionRenderer: (selector) => {
                        return _jsx(DropDown_Precondition.selectable, { queryFilter: item => {
                                return selector.existingItems.findIndex(precondition => precondition.itemPointer.id === item.item._id) === -1;
                            }, caret: QuaiManager_DropDownCaret, onSelected: pointer => {
                                selector.onSelected({
                                    itemPointer: {
                                        dbKey: pointer.dbKey,
                                        id: pointer.item._id,
                                    }
                                });
                                this.forceUpdate();
                            } });
                    } })] });
    };
    renderLogTemplates = () => {
        const pathwayState = this.state.editable;
        const logTemplates = ModuleFE_LogTemplate_OLD.cache.all();
        const adapter = SimpleListAdapter(logTemplates, log => _jsx(_Fragment, { children: log.item.title }));
        const selected = logTemplates.find(log => log._id === pathwayState.item.logTemplates?.[0]?.templateId);
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'pathway__form__label', children: "Smart Docs" }), _jsx(TS_DropDown, { caret: QuaiManager_DropDownCaret, adapter: adapter, selected: selected, onSelected: logTemplate => {
                        pathwayState.set('logTemplates', [{ templateId: logTemplate._id }]);
                    } })] });
    };
    childrenSelector = () => {
        const isParent = ModuleFE_Pathway.isParent(this.state.pathwayId);
        // If the pathway is not a parent or this state already exists
        if (!isParent || this.state.editable.get('_id'))
            return;
        return _jsx(Renderer_PathwayItemChildSelector, { onChangeCallback: pathwayIds => this.state.editable
                .updateObj({ pathwayIds: filterDuplicates([this.state.pathwayId, ...pathwayIds]) }), pathwayId: this.state.pathwayId, childFilter: child => true });
    };
    renderIgnoreDocumentation = () => {
        return _jsx(TS_Checkbox, { checked: this.state.editable.get('ignoreDocumentation'), onCheck: async (ignore) => {
                this.state.editable.set('ignoreDocumentation', ignore);
                this.forceUpdate();
            }, children: _jsx("div", { className: 'pathway__form__label', children: "Ignore Documentation" }) });
    };
}
//# sourceMappingURL=Renderer_PathwayStateEditor.js.map